import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';
import { ApplicationContextService }         from './app-context.service';
import {ColorMode }         from './app-context.service';
import { QuickLinkComponent }         from './quicklink.component';
// import { Hero }                from './hero';
// import { HeroService }         from './hero.service';

@Component({
//    moduleId: module.id,
    selector: 'ballpark',
  templateUrl: './ballpark.component.html',
  styleUrls:  ['./content.component.css','./ballpark.component.css']
})
export class BallparkComponent implements OnInit {

    constructor(
    private appContextService: ApplicationContextService,
    private router: Router) { }

  ngOnInit(): void {
     this.appContextService.SetURL(this.router.url);
     this.appContextService.SetSubject("Dětský kout na zahradě");
     this.appContextService.SetMode(ColorMode.Black);

  }

}
